import { atom } from 'recoil'

export const carouselState = atom({
  key: '_carouselState_',
  default: {
    withImage: true,
    selectedSlide: 0
  }
})
